export const METER_WATTWATCHERS_TROUBLESHOOTING_ARTICLE_URL =
  'https://support.clipsalcortex.com/hc/en-us/articles/7245710193295-How-to-power-cycle-your-Cortex-meter';

export const METER_CATCH_TROUBLESHOOTING_ARTICLE_URL =
  'https://support.clipsalcortex.com/hc/en-us/articles/12338844446479-How-to-reconnect-your-meter';

export const HYBRID_INVERTER_TROUBLESHOOTING_ARTICLE_URL =
  'https://support.clipsalcortex.com/hc/en-us/articles/7245912920847-Hybrid-inverter-No-communication-GoodWe-and-LG-';

export const SENSIBO_DEVICE_TROUBLESHOOTING_ARTICLE_URL =
  'https://support.clipsalcortex.com/hc/en-us/articles/13145819898127-How-to-reconnect-your-Sensibo-device';

export const EV_DEVICE_TROUBLESHOOTING_ARTICLE_URL =
  'https://support.clipsalcortex.com/hc/en-us/articles/13145838533775-How-to-reconnect-your-Schneider-Charger';

export const APP_FEEDBACK_URL = 'https://support.clipsalcortex.com/hc/en-us/requests/new';
